export { default } from "./HomeClaimLoadingView";
